// Global Instructions Rule Applied! - 2026-04-20

export type FetchPageResult<T> = {
  data: T[]
  hasMore: boolean
  error?: string
}

/**
 * Fetches all pages by repeating `fetchPage` until `hasMore` is false or a page returns no rows.
 */
export async function fetchAllPages<T>(options: {
  pageSize: number
  fetchPage: (page: number, pageSize: number) => Promise<FetchPageResult<T>>
}): Promise<{ data: T[]; error?: string }> {
  const { pageSize, fetchPage } = options
  const all: T[] = []
  let page = 1

  while (true) {
    const result = await fetchPage(page, pageSize)
    if (result.error) {
      return { data: all, error: result.error }
    }
    all.push(...result.data)
    if (!result.hasMore || result.data.length === 0) {
      break
    }
    page += 1
  }

  return { data: all }
}
